import {Component} from '@angular/core';
import { ConfigService } from '../config/config.service';
import {AuthService} from '../auth/services/auth-service';
import {Observable, take} from 'rxjs';
import {AuthenticatedResult, UserDataResult} from 'angular-auth-oidc-client';

@Component({
  selector: 'nav-bar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent  {
    isAuthenticated$: Observable<AuthenticatedResult>;
    userdata$: Observable<UserDataResult>;

    constructor(public readonly configService: ConfigService,
                protected readonly authService: AuthService) {
      this.isAuthenticated$ = authService.isAuthenticated();
      this.userdata$ = authService.getUser();
    }

    protected getUserName(): string {
      if (sessionStorage.getItem("session")) {
        this.userdata$.pipe(take(1)).subscribe((user) => {
          return user.userData['name']
        });
      } else {
        return 'Guest User'
      }
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}
